module.exports = __webpack_public_path__ + "static/img-hexapod-features-mobile-hr-43f1dd0608c2f4fa4d25e8fc51c9a898.png";